import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { initializeFirestore, connectFirestoreEmulator, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const dummyKey = 'AIzaSyMockKeyForEmulatorIsHere1234567890';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? dummyKey,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'freesplit-96da8.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'freesplit-96da8',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
};

// Use emulators if explicitly requested via environment variable
const useEmulators = import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
const isTestEnv = import.meta.env.MODE === 'test';

export const isConfigured = (!!firebaseConfig.apiKey && firebaseConfig.apiKey !== dummyKey) || useEmulators || isTestEnv;

const app = isConfigured ? initializeApp(firebaseConfig) : null;

if (!app) {
  throw new Error("Firebase app not configured");
}

// Configure Firestore with long-polling to avoid Webkit WebSocket issues in emulators
// and enable offline persistence via IndexedDB
export const db = useEmulators ? initializeFirestore(app, {
  experimentalForceLongPolling: true,
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
}) : initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const auth = getAuth(app);

export const functions = getFunctions(app, 'europe-west1');

if (useEmulators) {
  // Force local persistence so Playwright's storageState can capture the session (IndexedDB is invisible to it)
  setPersistence(auth, browserLocalPersistence).catch(console.error);
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  console.log("Connected to Firebase Emulators with Long Polling (127.0.0.1)");
}

export default app;
